module.exports = __webpack_public_path__ + "static/media/logo-small.184d36f4.svg";